import { useContext, useEffect } from "react";
import { LayoutContext } from "../contexts/LayoutContext";
import Matters from "../components/Matters/Matters";

function MatterManagementPage() {
  const { setIsContentScrollable } = useContext(LayoutContext);

  useEffect(() => {
    setIsContentScrollable(false);

    return () => {
      setIsContentScrollable(true);
    };
  }, [setIsContentScrollable]);

  return (
    <Matters />
  )
}

export default MatterManagementPage;